export default __webpack_public_path__ + "static/media/mydownloads.3f6a3337.svg";